const REHYDRATE = 'persist/REHYDRATE';
const SET_EXTENT = 'SET_EXTENT';
const MAP_LOADED = 'MAP_LOADED';
const MAP_COLUMN_VISIBLE = 'MAP_COLUMN_VISIBLE';

export default {
  REHYDRATE,
  SET_EXTENT,
  MAP_LOADED,
  MAP_COLUMN_VISIBLE
};



// WEBPACK FOOTER //
// ./src/redux/map/types.js